var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"mako-btn",attrs:{"disabled":_vm.disabled},on:{"click":_vm.callback}},[_vm._t("default",function(){return [_vm._v("Button")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }